import React, { useEffect, useState } from 'react';
import { Button } from '../../button/button';
import { adicionaZero } from '../Mask';
import { IcoArrowBack } from '../../icon/back-arrow-icon';
import { IcoArrowForward } from '../../icon/forward-arrow-icon';
import { IoReturnUpBackOutline } from 'react-icons/io5';

const dataInfo = {
  nomesDias: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  numeroSemanas: [1, 2, 3, 4, 5],
  numeroDiasSemana: [1, 2, 3, 4, 5, 6, 7],
  nomesMeses: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  nomesMesesAbv: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
};

export function CalendarYearMonth({
  name,
  label,
  action,
  value,
  dataInicio,
  dataFim,
  cy,
}) {
  let dataInicioSlice = dataInicio.split('/');
  let dataFimSlice = dataFim.split('/');
  let dataAtual = new Date();
  let dataAtualAno = dataAtual.getFullYear();
  let dataFimMes = dataFimSlice[0];
  let dataFimAno = dataFimSlice[1];
  let dataInicioMes = dataInicioSlice[0];
  let dataInicioAno = dataInicioSlice[1];
  const [calendarioMesAno, setcalendarioMesAno] = useState('year');
  const [selected, setSelected] = useState({ mes: '', ano: '' });
  const [dataState, setDataState] = useState({
    anoInicio: dataAtualAno - 6,
    anofim: dataAtualAno + 6,
    ano: dataAtualAno,
    anos: [],
    meses: dataInfo.nomesMesesAbv,
  });
  useEffect(() => {
    let anos = [];
    let anofim = dataAtualAno;
    let anoInicio = dataAtualAno - 6;

    if (dataFim && dataAtualAno + 6 >= dataFimAno) {
      anofim = dataFimAno;
      anoInicio = dataFimAno - 11;
      if (dataInicio && anoInicio <= dataInicioAno) {
        anoInicio = dataInicioAno;
      }
    }

    for (let i = 0; i < anofim - anoInicio + 1; i++) {
      anos = [...anos, parseInt(anoInicio) + i];
    }

    setDataState({ ...dataState, anos, anofim, anoInicio });
  }, []);
  useEffect(() => {
    if (Number(dataFimAno) === selected.ano) {
      const mesFimVisiviel = dataInfo.nomesMesesAbv.filter(
        (e, i) => i <= Number(dataFimMes)
      );
      setDataState({ ...dataState, meses: mesFimVisiviel });
    }
    if (Number(dataInicioAno) === selected.ano) {
      const mesInicioVisiviel = dataInfo.nomesMesesAbv.filter(
        (e, i) => i >= Number(dataInicioMes)
      );
      setDataState({ ...dataState, meses: mesInicioVisiviel });
    }
  }, [selected.ano]);

  const handleSelect = (e) => {
    setSelected({ ...selected, [e.name]: e.value });
    setcalendarioMesAno('months');
    if (selected.ano && e.name === 'mes') {
      action(
        { name, value: `${adicionaZero(e.number)}-${selected.ano}` },
        { name, message: false }
      );
    }
  };

  const handleLimpar = (e) => {
    setSelected({ mes: '', ano: '' });
    setcalendarioMesAno('year');
    action({ name, value: `` }, { name, message: false });
  };

  const seeMinus = (e) => {
    let anos = [];
    let anofim = parseInt(dataState.anos[0]);
    let anoInicio = parseInt(dataState.anos[0]) - 11;

    if (dataInicio && anoInicio <= dataInicioAno) {
      anoInicio = dataInicioAno;
      anofim =
        parseInt(dataInicioAno) + 11 <= dataAtualAno
          ? parseInt(dataInicioAno) + 11
          : parseInt(dataState.anos[dataState.anos.length - 1]);
      if (dataFim && dataState.anos[0] >= dataFimAno) {
        anofim = parseInt(dataFimAno);
      }
    }
    for (let i = 0; i < anofim - anoInicio + 1; i++) {
      anos = [...anos, parseInt(anoInicio) + i];
    }
    setDataState({ ...dataState, anos, anofim, anoInicio });
  };

  const seeMore = (e) => {
    let anos = [];
    let anofim = dataState.anos[dataState.anos.length] + 11;
    let anoInicio = dataState.anos[dataState.anos.length];
    dataFimAno = parseInt(dataFimAno);
    if (dataFim && dataAtualAno + 6 >= dataFimAno) {
      anofim = dataFimAno;
      anoInicio = dataFimAno - 11;
      if (dataInicio && anoInicio <= dataInicioAno) {
        anoInicio = dataInicioAno;
      }
    }

    for (let i = 0; i < anofim - anoInicio + 1; i++) {
      anos = [...anos, parseInt(anoInicio) + i];
    }
    setDataState({ ...dataState, anos, anofim, anoInicio });
  };
  return (
    <div data-cy={`${cy}Box`} className="box-calendario">
      <table>
        <thead>
          <tr>
            {calendarioMesAno === 'year' && dataInicio ? (
              <th>
                <Button
                  cy={`${cy}Minus`}
                  color="default"
                  type="btn circle navigation"
                  onClick={() => seeMinus()}
                  disabled={dataInicioAno <= dataState.anoInicio ? false : true}
                >
                  <IcoArrowBack />
                </Button>
              </th>
            ) : null}
            <th colSpan="5">
              {calendarioMesAno === 'year' ? (
                <span
                  style={{
                    fontSize: '16px',
                    padding: '5px 5px',
                    display: 'block',
                  }}
                >
                  {label}
                </span>
              ) : (
                <div>
                  <Button
                    data-cy={`${cy}SetYear`}
                    style={{
                      float: 'left',
                      border: 'none',
                      width: 'min-content',
                      padding: 0,
                      marginLeft: 4,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setcalendarioMesAno('year');
                      setDataState({
                        ...dataState,
                        meses: dataInfo.nomesMesesAbv,
                      });
                    }}
                  >
                    <IoReturnUpBackOutline />
                  </Button>
                  <span
                    style={{
                      fontSize: '16px',
                      padding: '5px 10px 5px 0px',
                      display: 'block',
                    }}
                  >
                    {selected.ano}
                  </span>
                </div>
              )}
            </th>
            <th>
              {calendarioMesAno === 'year' && dataFim ? (
                <Button
                  cy={`${cy}Forward`}
                  color="default"
                  onClick={() => seeMore()}
                  disabled={dataFimAno >= dataState.anofim ? false : true}
                  type="btn circle navigation"
                >
                  <IcoArrowForward />
                </Button>
              ) : null}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-cy={`${cy}Meses`} colSpan="7" className="btn-meses">
              {calendarioMesAno === 'year' ? (
                dataState?.anos ? (
                  dataState?.anos.map((e, i) => {
                    return (
                      <Button
                        cy={`${cy}Years${i}`}
                        key={i}
                        color={selected === e ? 'primary' : 'default'}
                        type="btn"
                        onClick={() => handleSelect({ name: 'ano', value: e })}
                        style={{ width: '68px' }}
                      >
                        {e}
                      </Button>
                    );
                  })
                ) : (
                  <>Carregando</>
                )
              ) : dataState?.meses ? (
                dataState?.meses.map((e, i) => {
                  return (
                    <Button
                      cy={`${cy}Meses${i}`}
                      key={i}
                      color={selected === e ? 'primary' : 'default'}
                      type="btn"
                      onClick={() =>
                        handleSelect({ name: 'mes', value: e, number: i + 1 })
                      }
                      style={{
                        width: `${
                          dataState.meses.length > 1 ? '33.333%' : '100%'
                        }`,
                      }}
                    >
                      {e}
                    </Button>
                  );
                })
              ) : (
                <>Carregando</>
              )}
            </td>
          </tr>
          <tr>
            <td colSpan="7">
              <div className="box-btn" style={{ margin: '10px 5px 5px 5px' }}>
                <Button
                  cy={`${cy}Clean`}
                  color={'primary'}
                  type="link"
                  onClick={() => handleLimpar()}
                  style={{ color: '#383939' }}
                >
                  Limpar
                </Button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
